import React 		from 'react'
import classnames 	from 'classnames'
import renderHTML 	from 'react-render-html'

import TextBlock 	from './default'

const Heading = (props) => {
	const {
		heading,
		headingEl
	} = props

	if(!heading){ return null }

	const _heading = renderHTML(heading)

	switch(headingEl){
		case 'h1':
			return <h1>{ _heading }</h1>
		case 'h3':
			return <h3>{ _heading }</h3>
		default:
			return <h2>{ _heading }</h2>
	}
}

export default (props) => {
	const {
		subheading,
		heading,
		logo,
		align,
		children,
		className
	} = props

	return <TextBlock
		type="intro"
		align={ align }
		subheading={ subheading }
		className={ className }>
		{ logo ? <div className={ classnames('productLogo', `productLogo--${ logo }`, {
				'productLogo--secondary': !!heading
			}) } /> : null }
		<Heading { ...props } />
		{ children ? children : null }
	</TextBlock>
}
